import { render, staticRenderFns } from "./TabModeratorPlayerStudent.vue?vue&type=template&id=5be172b8&"
import script from "./TabModeratorPlayerStudent.vue?vue&type=script&lang=js&"
export * from "./TabModeratorPlayerStudent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports